import {kModalStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kGlossaryImages} from "../../../constants/images";
import Modal from "@mui/material/Modal";

export default function GlossaryScreenInfoDialog({open, handleClose}) {
    // Used in

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogMediumStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.dictionary}
                                        title={"Glossaire mathématique"} />
                {/** CONTENT */}
                <div className={"w-full flex justify-start items-start space-x-[32px] px-[24px] pt-[24px] pb-[16px]"}>
                    <div className={"w-[136px] min-w-[136px]"}>
                        <img
                            className={"object-contain h-full w-full"}
                            src={kGlossaryImages.screenInfoImage}
                            alt="Ours avec stylo et cahier"
                        />
                    </div>
                    <div className={"w-full flex flex-col justify-start items-start"}>
                         <span className={"font-bold text-[18px] text-white -mt-[6px]"}>
                           {"Tu es en difficulté face à un mot ou un verbe dans une consigne\u00A0?"}
                        </span>
                        <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                            {"Avec le glossaire, on te donne pour chaque mot ou verbe sa définition, un exemple mathématique et une situation du quotidien où tu l'utilises sans même t'en rendre compte. Les mathématiques, c'est aussi une histoire de français\u00A0!"}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
}